var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrinticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.106,
    height: 17.576,
    viewBox: "0 0 18.106 17.576",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Print_icon",
    "data-name": "Print icon",
    d: "M369.092-433.424A2.089,2.089,0,0,1,367-435.5v-3.389a2.089,2.089,0,0,1,2.092-2.081h.951v-7.406a2.6,2.6,0,0,1,.771-1.853,2.636,2.636,0,0,1,1.863-.767h3.7a2.613,2.613,0,0,1,1.863.768l3.161,3.143a2.615,2.615,0,0,1,.767,1.853v4.261h.85a2.089,2.089,0,0,1,2.093,2.081v3.389a2.089,2.089,0,0,1-2.093,2.081Zm-.815-5.469v3.389a.814.814,0,0,0,.815.811h13.921a.814.814,0,0,0,.815-.811v-3.389a.814.814,0,0,0-.815-.812H369.092A.814.814,0,0,0,368.277-438.893Zm3.514-10.368a1.252,1.252,0,0,0-.367.881v7.406h9.359v-4.262a1.01,1.01,0,0,0-.007-.114h-1.663a2.623,2.623,0,0,1-1.862-.767,2.607,2.607,0,0,1-.771-1.852v-1.651c-.038,0-.074-.006-.111-.006h-3.692A1.249,1.249,0,0,0,371.791-449.262Zm6.073,1.292a1.233,1.233,0,0,0,.367.881,1.274,1.274,0,0,0,.885.365h.689l-1.942-1.931Z",
    transform: "translate(-367 451)",
    fill: "#00246a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinticon);
export default __webpack_public_path__ + "static/media/Print icon.3d44251af77ca0ffd1b310dcc1537d0b.svg";
export { ForwardRef as ReactComponent };